(function($){
	//Handle clicks to open a gallery
	$(document).on('click', '.archive-gallery-item', function(e) {
		e.preventDefault();

		if (!$(this).hasClass('initialized')) {
			//Initialize magnific popup
			$(this).magnificPopup({
				type: 'inline',
				items: [
					{
						src: '#'+$(this).attr('data-gallery-id'),
						type: 'inline'
					}
				],
				closeOnBgClick: true,
				closeOnContentClick: false,
				showCloseBtn: true,
				closeBtnInside: true,
				enableEscapeKey: false,
				callbacks: {
					open: function() {
						$('body').addClass('modal-open');
					},
					close: function() {
						$('body').removeClass('modal-open');
					}
				}
			});

			//Initialize slick slider
			$(this).find('.gallery-slides').slick({
				lazyLoad: 'ondemand',
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true
			});

			//Resize after image loaded
			$(this).find('.gallery-slides').on('lazyLoaded', function(event, slick, image, imageSource) {
				$('.gallery-slides.slick-initialized').slick('resize');
			});
		}
		else {
			$('.gallery-slides.slick-initialized').slick('slickGoTo', 0);
		}

		$(this).addClass('initialized');
		$(this).click();
	});

	//Gallery filters
	if ($('.gallery-filters').length) {
		$('.gallery-filters a').attr('href', '');

		$('.gallery-filters a').click(function(e) {
			e.preventDefault();

			$('.gallery-filters li.current_page_item').removeClass('current_page_item');

			let service = $(this).parent().attr('data-service');

			$('.gallery-filters li[data-service='+service+']').addClass('current_page_item');

			//Check the hidden filter and submit and such
			$('#service-select').val(service == 'all' ? '' : service).trigger('change');
		});
	}

	//Initialize single gallery
	$('.single-gallery .gallery-slides').slick({
		lazyLoad: 'ondemand',
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true
	});

	//Resize after image loaded
	$('.single-gallery .gallery-slides').on('lazyLoaded', function(event, slick, image, imageSource) {
		$('.gallery-slides.slick-initialized').slick('resize');
	});
})(jQuery);
